"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAll = exports.timezoneString = exports.timezoneOffset = exports.referrer = exports.language = void 0;
// @ts-ignore userLanguage is just for IE11
exports.language = navigator.userLanguage || navigator.language;
exports.referrer = function () {
    var referrerStr = "";
    try {
        referrerStr = window.top.document.referrer;
    }
    catch (e) {
        if (window.parent) {
            try {
                referrerStr = window.parent.document.referrer;
            }
            catch (e1) {
                referrerStr = "";
            }
        }
    }
    if (referrerStr === "") {
        referrerStr = window.document.referrer;
    }
    return referrerStr;
};
exports.timezoneOffset = new Date().getTimezoneOffset();
exports.timezoneString = String(String(new Date()).split("(")[1]).split(")")[0];
// This fills out the 'page' section of an event
function getAll() {
    var docHeight = Math.max(
    // @ts-ignore TODO: reference window.parent ?
    document.documentElement.clientHeight, document.body.scrollHeight, 
    // @ts-ignore TODO: reference window.parent ?
    document.documentElement.scrollHeight, document.body.offsetHeight, 
    // @ts-ignore TODO: reference window.parent ?
    document.documentElement.offsetHeight);
    var docWidth = Math.max(
    // @ts-ignore TODO: reference window.parent ?
    window.document.documentElement.clientWidth, 
    // @ts-ignore TODO: reference window.parent ?
    window.document.documentElement.offsetWidth, 
    // @ts-ignore TODO: reference window.parent ?
    window.document.documentElement.scrollWidth);
    return {
        page_document_size_height: docHeight,
        page_document_size_width: docWidth,
        page_page_offset_left: Math.max(window.pageXOffset || document.body.scrollLeft || 0),
        page_page_offset_top: Math.max(window.pageYOffset || document.body.scrollTop || 0),
        page_title: window.document.title,
        page_url: window.location.href,
        page_viewport_height: window.innerHeight,
        page_viewport_width: window.innerWidth,
        page_language: exports.language,
        page_referrer: exports.referrer(),
        page_timezone_offset: exports.timezoneOffset,
        page_timezone_string: exports.timezoneString,
        timestamp_created: Date.now(),
    };
}
exports.getAll = getAll;
